import { vsName as componentName } from "./component";
import {
  MachineDetailTabsProvider,
  vsProviderName as machineDetailTabsProviderName,
} from "../../../../../shared/components/views/machines/detail/tabs";
import { MachineGateway } from "../../../../models/machine";
import { vsName as partTransactionComponentName } from "../../../../../../parts/Pages/detail/partTransaction";

import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../records/server/serverUtility";

export function machineDetailPartsComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) { 
  machineDetailTabsProvider.addElement({
    displayName: "Part Transactions",
    id: "parts",
    uiSrefFragment: "parts",
    requiredPermission: "machineView",
    stateDefinition: {
      url: "/parts",
      component: partTransactionComponentName,
      resolve: {
        partTransaction: [
          "machine",
          serverUtilityName,
          (machine: MachineGateway, serverUtility: ServerUtility) => {
            if (!machine || !machine.Id) {
              return [];
            }
  
            return serverUtility.sendApiRequest({
              method: "GET",
              url: "/api/parts/partTransaction",
              params: {
                ContextPath: "MachineId",
                ContextValue: machine.Id,
              },
            });
          },
        ],
  
        part: [
          "machine",
          (machine: MachineGateway) => ({
            Id: null,
            PartNumber: "Machine Parts",
            PartDescription: machine.Name,
          }),
        ],
      },
    },
  })
  ;
}
machineDetailPartsComponentConfig.$inject = [machineDetailTabsProviderName];
